import { render, staticRenderFns } from "./voucherRecordView.vue?vue&type=template&id=8ed42e2a&scoped=true&"
import script from "./voucherRecordView.vue?vue&type=script&lang=js&"
export * from "./voucherRecordView.vue?vue&type=script&lang=js&"
import style0 from "./voucherRecordView.vue?vue&type=style&index=0&id=8ed42e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed42e2a",
  null
  
)

export default component.exports